// extracted by mini-css-extract-plugin
export default {"control":"AddJoke_control__Aq-M2"};